// The worker calls skipWaiting itself, so once a new build's worker activates, a page still running
// the previous build reloads onto it.
export const registerServiceWorker = async (onRegistered: (registration: ServiceWorkerRegistration) => void) => {
  if (!('serviceWorker' in navigator)) return;

  const { Workbox } = await import('workbox-window');
  const workbox = new Workbox('/serviceWorker.js', { scope: '/', type: 'classic' });

  workbox.addEventListener('activated', (event) => {
    if (event.isUpdate || event.isExternal) window.location.reload();
  });

  const registration = await workbox.register({ immediate: true }).catch(() => undefined);
  if (registration) onRegistered(registration);
};
